// Design tokens — keep in lockstep with tailwind.config.ts.
// We export them in TS too so they're available to inline SVG / dynamic styles.

export const colors = {
  ink: '#1A1614',
  inkLight: '#6B5F58',
  inkSofter: '#A39A92',
  cream: '#FAF6F0',
  paper: '#F5EEE2',
  // Soft warm-grey used as the default border on cream surfaces (chat
  // bubbles, stat cards, inputs). Evokes morning mist on rice paper. Focus
  // states transition mist → vermillion.
  mist: '#D6CFC1',
  vermillion: '#E94B3C',
  vermillionDeep: '#C73E32',
  coral: '#FFB5A8',
  blush: '#FFE5DD',
  gold: '#C9A36A',
  jade: '#5C8A6B',
} as const;

export type ColorToken = keyof typeof colors;

// Compact alias used by ported components. Mirrors the beta's C palette
// one-to-one so we can paste-port without rewriting inline styles.
export const C = {
  ink: colors.ink,
  cream: colors.cream,
  paper: colors.paper,
  mist: colors.mist,
  vermillion: colors.vermillion,
  vermillionDeep: colors.vermillionDeep,
  coral: colors.coral,
  blush: colors.blush,
  gold: colors.gold,
  jade: colors.jade,
  inkLight: colors.inkLight,
  inkSofter: colors.inkSofter,
} as const;

export const motion = {
  // Used by JS code to gate animations when prefers-reduced-motion is on.
  fast: 200,
  base: 450,
  slow: 1400,
} as const;
